import { Component, input } from '@angular/core';

/** White content card used by the sign-up page sections; `decorated` adds the Yellow-100 corner accent. */
@Component({
  selector: 'app-signup-card',
  standalone: true,
  template: `
    @if (decorated()) { <div class="accent" aria-hidden="true"></div> }
    <div class="content"><ng-content /></div>
  `,
  styles: `
    :host {
      display: block; position: relative; overflow: hidden;
      background: var(--kin-white); border-radius: var(--kin-radius-card); padding: 40px;
      box-shadow: var(--kin-shadow-md);
    }
    .accent {
      position: absolute; top: -60px; right: -60px; width: 200px; height: 200px;
      border-radius: var(--kin-radius-pill); background: var(--kin-yellow-100);
    }
    .content { position: relative; }
    @media (max-width: 600px) {
      :host { padding: 24px 20px; }
    }
  `,
})
export class SignupCardComponent {
  readonly decorated = input(false);
}
